import { HttpTimeoutError, UnknownError } from '@cian/peperrors/shared';
import { Response } from './Response.mjs';

class FetchRequest {
    isDestroyed = false;
    requestConfig;
    timeout;
    requestServerName;
    responseType;
    abortController;
    abortRequestReason;
    constructor(params) {
        this.requestConfig = params.requestConfig;
        this.timeout = params.timeout;
        this.requestServerName = params.requestServerName;
        this.responseType = params.responseType;
    }
    async send() {
        const { url, method, headers, withCredentials, body } = this.requestConfig;
        const credentials = withCredentials ? 'include' : 'same-origin';
        this.abortController = new AbortController();
        if (this.abortRequestReason) {
            this.abortController.abort();
        }
        const stringUri = url.toString();
        const reqParams = {
            method,
            headers: headers.toArray(),
            credentials,
            signal: this.abortController.signal,
        };
        if (method === 'POST') {
            reqParams.body = body;
        }
        const req = new Request(stringUri, reqParams);
        const timeout = setTimeout(() => this.destroy(new HttpTimeoutError(`Microservice ${this.requestServerName} api ${stringUri} not answers in ${this.timeout} milliseconds`, `http-api.request-timeout.${this.requestServerName}`)), this.timeout);
        try {
            const res = await fetch(req);
            clearTimeout(timeout);
            return new Response({
                reqConfig: this.requestConfig,
                rawHeaders: res.headers,
                response: res,
                statusCode: res.status,
                responseType: this.responseType,
            });
        }
        catch (error) {
            clearTimeout(timeout);
            if (error.name === 'AbortError') {
                if (this.abortRequestReason) {
                    throw this.abortRequestReason;
                }
                const err = new UnknownError({
                    message: error.message,
                    domain: `http-api.FetchRequest.${this.requestServerName}`,
                });
                err.name = 'AbortError';
                throw err;
            }
            throw error;
        }
    }
    destroy(cause) {
        if (cause) {
            this.abortRequestReason = cause;
        }
        if (this.abortController) {
            this.isDestroyed = true;
            this.abortController.abort();
        }
    }
}

export { FetchRequest };
//# sourceMappingURL=FetchRequest.mjs.map
